import React, { useState } from "react";
import "./view.less";
import Nav from "../components/navbar/Nav";
import Header from "../components/header/Header";

function ResponsiveDrawer(props) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(prev => !prev);
  const handleDrawerClose = () => setMobileOpen(false);

  return (
    <div className="layout">
      <div className="layout-nav">
        {/* Mobile drawer */}
        <div className={`mobile-overlay${mobileOpen ? " open" : ""}`} onClick={handleDrawerClose} />
        <div className={`mobile-drawer${mobileOpen ? " open" : ""}`}>
          <Nav />
        </div>
        {/* Desktop nav */}
        <div className="desktop-nav">
          <Nav />
        </div>
      </div>
      <div className="layout-header">
        <Header name={props.name} click={handleDrawerToggle} />
      </div>
      <div className="layout-content">
        {props.page}
      </div>
    </div>
  );
}

export default ResponsiveDrawer;
